// extracted by mini-css-extract-plugin
export default {"iconsRow":"iconsRow-tVzI1rN0","textsContainer":"textsContainer-SsN1WBw2","textsWrapper":"textsWrapper-u8OlCusq","textSection":"textSection-zjCvIlUY"};